import {Component, Input, OnInit} from '@angular/core';
import {ContactInfoModel} from "../../domain/models/contact-info.model";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {RouterModule} from "@angular/router";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {MatCardModule} from "@angular/material/card";
import {MatDividerModule} from "@angular/material/divider";
import {CommonModule} from "@angular/common";
import {CompanyInfoModel} from "../../domain/models/company-info.model";

@Component({
  selector: 'app-company-info-card',
  standalone: true,
  imports: [
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    FormsModule,
    RouterModule,
    MatInputModule,
    MatSelectModule,
    MatCardModule,
    ReactiveFormsModule,
    MatDividerModule,
    CommonModule
  ],
  templateUrl: './company-info-card.component.html',
  styleUrl: './company-info-card.component.css'
})
export class CompanyInfoCardComponent implements OnInit{
  @Input() companyInfo: CompanyInfoModel = {};
  form!: FormGroup;
  constructor(private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.buildForm(this.companyInfo);
  }

  buildForm(info: CompanyInfoModel): void {
    this.form = this.fb.group({
      businessLegalName: [info.businessLegalName?? null, Validators.required],
      businessDbaName: [info.businessDbaName?? null, Validators.required],
      webSiteUrl: [info.webSiteUrl?? null, [Validators.required,
        Validators.pattern(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/)]],
    });
  }

  getModelFromForm(): CompanyInfoModel {
    return {
      businessLegalName: this.form.get('businessLegalName')?.value ?? null,
      businessDbaName: this.form.get('businessDbaName')?.value ?? null,
      webSiteUrl: this.form.get('webSiteUrl')?.value ?? null
    };
  }

  isFormValid(): boolean {
    return this.form.valid;
  }
}
